import { ShipmentStatus } from '../interfaces';

export default function mapShipmentToStatus(shipment: any) {
  let status = ShipmentStatus.IN_PROGRESS;;
  if (shipment.is_cancel_completed) {
    status = ShipmentStatus.CANCELLED;
  } else if (shipment.is_cancel) {
    status = ShipmentStatus.CANCELLING;
  } else if (shipment.is_delivered) {
    status = ShipmentStatus.DELIVERED;
  }
  return status;
};
